import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { encryptData, serverLink } from "../../../resources/url";
import DataLoader from "../../common/dataLoader/dataLoader";
import DataTable from "../../common/data-table/data-table";
import { formatDateAndTime } from "../../../resources/constants";
import ApplicantSelectOption from "../../common/dynamic-select-option/applicant-select-option";
import { Link } from "react-router-dom";

function SearchStudent(props) {
    const [isLoading, setIsLoading] = useState(false);
    const [showTBL, setShowTBL] = useState(false);
    const [studentList, setStudentList] = useState([]);

    const header = ["S/N", "Student ID", "Name", "Gender", "Nationality", "State Of Origin", "Date Of Birth", "Programme", "Admission Year", "Action"];

    const [formData, setFormData] = useState({
        APPID: "",
        PROG_ID: "",
        INSERTED_BY: `${props.loginData[0]?.StaffID}`,
    });

    useEffect(() => {
        if (formData.APPID !== "") {
            getData(formData.APPID);
        }
    }, [formData.APPID]);

    const getData = async (app_id) => {
        setIsLoading(true);
        try {
            const { data } = await axios.get(`${serverLink}staff/report/registered/student/details/${app_id}`);
            setStudentList(data);
            setShowTBL(true);
        } catch (err) {
            console.error("Network error fetching student data", err);
        } finally {
            setIsLoading(false);
        }
    };

    const showTable = () => {
        return studentList.map((item, index) => (
            <tr key={index}>
                <td className="text-muted w-1">{index + 1}</td>
                <td>
                    <span className="badge bg-blue-lt fw-medium">{item.STUDENTID || item.APPID}</span>
                </td>
                <td className="fw-medium">{item.STUDENT_NAME}</td>
                <td>
                    <span className={`badge ${item.GENDER === "Male" ? "bg-azure-lt" : "bg-pink-lt"}`}>
                        {item.GENDER}
                    </span>
                </td>
                <td>{item.NATIONALITY}</td>
                <td>{item.STATE_OF_ORIGIN}</td>
                <td className="text-muted">
                    {item.DOB ? formatDateAndTime(item.DOB, "date") : <span className="text-muted">—</span>}
                </td>
                <td style={{ maxWidth: "200px" }}>
                    <div className="text-truncate" title={item.PROGRAMME}>{item.PROGRAMME}</div>
                </td>
                <td>
                    <span className="badge bg-green-lt">{item.ADMISSION_YEAR}</span>
                </td>
                <td>
                    <Link
                        to={`/hr/student-manager/dashboard/${encryptData(item.APPID)}`}
                        className="btn btn-sm btn-primary d-inline-flex align-items-center gap-1"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-sm" width="16" height="16"
                             viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                             strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                            <rect x="3" y="5" width="18" height="14" rx="2"/>
                            <path d="M3 10h18"/>
                        </svg>
                        Dashboard
                    </Link>
                </td>
            </tr>
        ));
    };

    return (
        <>
            <div className="container-xl">
                <div className="page-header d-print-none">
                    <div className="row align-items-center">
                        <div className="col">
                            <div className="page-pretitle">Human Resources / Student Manager</div>
                            <h2 className="page-title d-flex align-items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" className="icon text-primary" width="24"
                                     height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
                                     fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                    <circle cx="10" cy="10" r="7"/>
                                    <line x1="21" y1="21" x2="15" y2="15"/>
                                </svg>
                                Search Student
                            </h2>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body">
                <div className="container-xl">
                    <div className="row row-deck row-cards">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex align-items-center gap-2">
                                        <span className="avatar avatar-sm bg-primary-lt text-primary">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="20"
                                                 height="20" viewBox="0 0 24 24" strokeWidth="2"
                                                 stroke="currentColor" fill="none" strokeLinecap="round"
                                                 strokeLinejoin="round">
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                <circle cx="12" cy="7" r="4"/>
                                                <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"/>
                                            </svg>
                                        </span>
                                        <h3 className="card-title mb-0">Student Lookup</h3>
                                    </div>
                                    {showTBL && studentList.length > 0 && (
                                        <div className="card-options">
                                            <span className="badge bg-success">
                                                {studentList.length} result{studentList.length !== 1 ? "s" : ""}
                                            </span>
                                        </div>
                                    )}
                                </div>

                                <div className="card-body border-bottom">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-md-7">
                                            <label className="form-label fw-semibold">Select Student</label>
                                            <ApplicantSelectOption
                                                formData={formData}
                                                setFormData={setFormData}
                                                placeholder="Type name, student ID or application ID..."
                                            />
                                            <div className="form-hint mt-1 d-flex align-items-center gap-1">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-sm text-muted" width="14" height="14"
                                                     viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none"
                                                     strokeLinecap="round" strokeLinejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                    <circle cx="12" cy="12" r="9"/>
                                                    <line x1="12" y1="8" x2="12.01" y2="8"/>
                                                    <polyline points="11 12 12 12 12 16 13 16"/>
                                                </svg>
                                                Search by name, student ID, or application ID
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body p-0">
                                    {isLoading ? (
                                        <div className="d-flex justify-content-center align-items-center py-5">
                                            <DataLoader />
                                        </div>
                                    ) : showTBL ? (
                                        studentList.length > 0 ? (
                                            <DataTable
                                                header={header}
                                                body={showTable()}
                                                title="Student Search Results"
                                            />
                                        ) : (
                                            <div className="empty py-5">
                                                <div className="empty-icon">
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-lg text-muted"
                                                         width="48" height="48" viewBox="0 0 24 24" strokeWidth="1.5"
                                                         stroke="currentColor" fill="none" strokeLinecap="round"
                                                         strokeLinejoin="round">
                                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                        <circle cx="10" cy="10" r="7"/>
                                                        <line x1="21" y1="21" x2="15" y2="15"/>
                                                        <line x1="7" y1="10" x2="13" y2="10"/>
                                                    </svg>
                                                </div>
                                                <p className="empty-title">No student found</p>
                                                <p className="empty-subtitle text-muted">
                                                    No records match the selected criteria.
                                                </p>
                                            </div>
                                        )
                                    ) : (
                                        <div className="empty py-5">
                                            <div className="empty-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-lg text-muted"
                                                     width="48" height="48" viewBox="0 0 24 24" strokeWidth="1.5"
                                                     stroke="currentColor" fill="none" strokeLinecap="round"
                                                     strokeLinejoin="round">
                                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                                                    <circle cx="12" cy="7" r="4"/>
                                                    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"/>
                                                </svg>
                                            </div>
                                            <p className="empty-title">Search for a student</p>
                                            <p className="empty-subtitle text-muted">
                                                Select a student from the dropdown above to view their details and navigate to their dashboard.
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    loginData: state.loginDetails,
});

export default connect(mapStateToProps, null)(SearchStudent);
